import axios from "axios";
import NProgress from "nprogress";

const YamahaApi = class YamahaApi {
  constructor(tipo, headers) {
    // Por defecto se utiliza la conexión a Yamaha Web
    this.apiLocation = tipo || "WEB";
    this.apiAditionalHeaders = headers || null;
    this.endpointUrlPrefix = this.apiLocation === "WEB" ? "/yamaha/v1" : "";

    this.axiosInstance = axios.create({
      withCredentials: false,
      headers: {
        common: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    });

    this.initAxiosRequestInterceptors();
  }

  get instance() {
    return this.axiosInstance;
  }

  get endpointPrefix() {
    return this.endpointUrlPrefix;
  }

  initAxiosRequestInterceptors() {
    // Intercepta el request y agtega parámetros adicionales de configuración
    this.axiosInstance.interceptors.request.use(config => {
      NProgress.start();

      // URL Base para las peticiones
      config.baseURL =
        this.apiLocation === "WEB"
          ? process.env.VUE_APP_YAMAHA_WEB_REST_API
          : process.env.VUE_APP_YAMAHA_BO_REST_API;

      // Token para Yamaha BackOffice
      if (this.apiLocation === "BO") {
        config.headers["X-YAMAHA-API-TOKEN"] =
          process.env.VUE_APP_YAMAHA_API_TOKEN;
      }

      // Agrega los encabezados adicionales
      if (this.apiAditionalHeaders) {
        Object.keys(this.apiAditionalHeaders).forEach(key => {
          config.headers[key] = this.apiAditionalHeaders[key];
        });
      }

      return config;
    });

    // Intercepta la respuesta para detener NProgress
    this.axiosInstance.interceptors.response.use(
      response => {
        NProgress.done();
        return response;
      },
      error => {
        NProgress.done();
        return Promise.reject(error);
      }
    );
  }
};

export default YamahaApi;
